import React from 'react';

interface ISecondaryButton {
  label: string;
  disabled?: boolean;
  Icon?: React.ComponentType<{}>;
  width?: string;
  onClick: () => void;
  background?: string;
  height?: string;
  text?: string;
}
const PrimaryDarkButton: React.FC<ISecondaryButton> = ({
  label = '',
  disabled = false,
  Icon,
  width = '',
  onClick = () => {},
  background = '',
  height = '',
  text = '',
}) => {
  return (
    <div
      className={`flex items-center cursor-pointer rounded-1 text-white px-4 py-2  ${
        background ? background : 'bg-primaryDark'
      } ${height ? height : 'h-[36px]'} ${width ? width : 'w-fit'} gap-x-2 ${
        disabled ? 'opacity-50 pointer-events-none' : ''
      }`}
      onClick={onClick}
    >
      {Icon ? <Icon /> : <></>}
      <label
        className={`text-white ${
          text ? text : 'text-sm'
        }  mx-auto font-medium whitespace-nowrap cursor-pointer`}
      >
        {label}
      </label>
    </div>
  );
};

export default PrimaryDarkButton;
